import React from 'react';
import M from 'materialize-css';
import { Link } from 'react-router-dom';
import { dateToLL } from '../../utils/DateUtil';

function WeeklyMission({ mission }) {
  const copyIdToClipboard = () => {
    navigator.clipboard.writeText(mission.id);
    M.toast({ html: 'ID copied' });
  };

  const renderDates = () => {
    const { startDate, endDate } = mission;
    const start = dateToLL(startDate.toDate());
    const end = dateToLL(endDate.toDate());
    return startDate && endDate ? <p className="company-address">{`${start} - ${end}`}</p> : <p className="company-address">&nbsp;</p>;
  };

  const renderWeeklyMissionData = () => (
    <div className="card-content grey-text text-darken-3">
      <span className="card-email">{mission.name}</span>
      {renderClickableId()}
      {renderDates()}
    </div>
  );

  const renderClickableId = () =>
    mission.id ? (
      <p className="company-address">
        {`ID: `}
        <Link to={window.location} onClick={() => copyIdToClipboard()}>
          {mission.id}
        </Link>
        {mission.activated && <span className="new badge" data-badge-caption="ACTIVE"></span>}
      </p>
    ) : null;

  return (
    <div className="col s12 m6">
      <div className="card z-depth-0 project-summary">
        {renderWeeklyMissionData()}
        <div className="card-action-disabled">
          <Link
            className="btn-flat"
            to={{
              pathname: '/newMission',
              mission: mission,
              edit: true,
            }}>
            Edit
          </Link>
        </div>
      </div>
    </div>
  );
}

export default WeeklyMission;
